import api from './api';

const holidayService = {
  getAllHolidays: (token) => {
    const headers = { 'auth-key': token };
    return api.get('/Holiday/GetAllHolidays', null, headers);
  },

  addHoliday: (data, token) => {
    const headers = { 'auth-key': token };
    const params = {
      p_holidayDate: data.holidayDate,
      p_holidayName: data.holidayName,
      p_holidayType: data.holidayType,
      p_isActive: data.isActive ? 1 : 0,
      p_createdBy: data.createdBy || 'admin',
      p_remarks: data.remarks || ''
    };
    return api.post('/Holiday/AddHoliday', params, token);
  },
  

 updateHoliday: (data, token) => {
    const headers = { 'auth-key': token };
    const params = {
      p_holidayId: data.holidayId,
      p_holidayName: data.holidayName,
      p_holidayType: data.holidayType,
      p_holidayDate: data.holidayDate,
      p_isActive: data.isActive ? 1 : 0,
      p_updatedBy: data.updatedBy || 'admin',
      p_remarks: data.remarks || ''
    };
    return api.post('/Holiday/UpdateHoliday', params, token);
  },

  
  deleteHoliday: (holidayId, token) => {
    const headers = { 'auth-key': token };
    return api.delete(`/Holiday/DeleteHoliday/${holidayId}`, token);
  }
};

export default holidayService;